import { ChangeDetectionStrategy, Component, ChangeDetectorRef } from '@angular/core';
import { MeasureVO } from '@wizeoo/akm-compute-lib';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

/**
 * renderer FD ou chrono (icone selon le Kind)
 */
@Component({
  selector: 'measure-kind-renderer',
  template: `<wiz-hgroup height="100%" width="100%" verticalAlign="center" horizontalAlign="center">
    <wiz-icon *ngIf="showPen" style="font-size: 16px;" [wizTooltip]="'$.measure.kind.editable.$'">edit</wiz-icon>
    <wiz-icon *ngIf="showWeight" style="font-size: 16px;" [wizTooltip]="'$.measure.kind.weight.$'">weight-grid</wiz-icon>
    <wiz-icon *ngIf="showConstant" style="font-size: 16px;" [wizTooltip]="'$.measure.kind.constant.$'">constant</wiz-icon>
  </wiz-hgroup>`,
  styles: [':host {height:100%; width: 100%; max-width: 100%}'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MeasureKindRenderer implements AgRendererComponent {
  public showPen: boolean = false; // affichage du crayon d'édition, si éditable et mode I
  public showWeight: boolean = false; // affichage du poids si WeightGrid
  public showConstant: boolean = false; // affichage si constante
  public hasError: boolean = false; // erreur de formule

  private _data: MeasureVO;
  public get data(): MeasureVO {
    return this._data;
  }
  public set data(data: MeasureVO) {
    this._data = data;
    this.showPen = data.editable;
    this.showWeight = data.isWeight;
    this.showConstant = data.isConstant;

    this.hasError = data.hasError;
  }

  constructor(private cdref: ChangeDetectorRef) {}

  refresh(params: ICellRendererParams): boolean {
    this.data = params.data;
    this.cdref.markForCheck();
    return true;
  }

  agInit(params: ICellRendererParams) {
    this.data = params.data;
    this.cdref.markForCheck();
  }
}
